export default __webpack_public_path__ + "static/media/sankalp-team.5ac2cf4e.jpeg";